import { RESET } from '../actionTypes';
import { productThumbnailActions } from '../reducer';

export default () => productThumbnailActions[RESET](null);
